import { TReportingFilters } from '../../../models/types'

export const selectReportingFilters = ({
  reportingFilters: reportingFiltersState,
}: {
  reportingFilters: TReportingFilters
}): TReportingFilters => reportingFiltersState
